import React from 'react';
import { Link } from 'react-router-dom';
import { KoobButton, KoobCard } from '@koob/ui';
import { useTranslation } from 'react-i18next';

export default function PromotionsBottomBar({
  onReset,
  isApplyDisabled,
  clearToConnectionRequestModel,
}) {
  const { t } = useTranslation('toConnectionRequest');

  return (
    <KoobCard>
      <div className="flex justify-between items-center">
        <div className="flex space-x-3">
          <Link
            to="/to-connection-request/connections"
            onClick={() => clearToConnectionRequestModel()}
          >
            <KoobButton color="secondary">{t('promotions.quit')}</KoobButton>
          </Link>

          <KoobButton color="secondary" onClick={onReset}>
            {t('misc:resetForm')}
          </KoobButton>
        </div>

        <div className="flex space-x-3">
          <KoobButton type="submit" color="primary" disabled={isApplyDisabled}>
            {t('bulkEdit.applyButton')}
          </KoobButton>
        </div>
      </div>
    </KoobCard>
  );
}
